
var configurationManager = require('../config/configurationManager.js');
var logger = require('../logger/logger');
var typeUtil = require('../type/typeUtil');
var localizationUtils = require('../domain/localizationUtils');
var terminalUtility = require('../domain/terminalUtility.js');

module.exports.displaySale = function(sale, resolvedLocalizationSettings)
{
    if (terminalUtility.isRunningUnderBrowserShell())
        return;

    var shellAPIServerUrl = getShellApiServerUrl();

    try
    {
        var requestBody = {};
        requestBody.method = 'POST';
        requestBody.headers = {
                                    "Content-Type": "application/json",
                              }
    
        var body = {};
        body.command = "signage.player.open.sale";
        body.payload = this.prepareSaleForSignageScreen(sale, resolvedLocalizationSettings);
        requestBody.body =  JSON.stringify(body);
    
        fetch(shellAPIServerUrl, requestBody)
            .then(function(response)
            {
                if (response.status != 200)
                    logger.error(`Invalid response ${response.status} received from hardware services api server (${shellAPIServerUrl}).`);
                else
                    logger.info('Successfully sent payload to hardware services api server.');
                return null;
            }, 
            error =>
            {
                var errorMessage = error.message;
                if (!errorMessage) errorMessage = error;
                logger.error(`Following error reported while accessing hardware services api server (${shellAPIServerUrl}):  ${errorMessage}`, {}, error);
                return null;
            });
    }
    catch(error)
    {
        logger.error(`Following error reported while accessing hardware services api server (${shellAPIServerUrl}):  ${error}`, {}, error);
    }
    
}
module.exports.prepareSaleForSignageScreen = function(sale, resolvedLocalizationSettings)
{
    //Redux state cannot be accessed during reduction flow. Hence passing resolvedLocalizationSettings as parameter
    var clonedSale = typeUtil.deepCloneObject(sale);

    clonedSale.signageMetaData = {};
    clonedSale.signageMetaData.currencySymbol = resolvedLocalizationSettings[localizationUtils.attributes.currencySymbol];
    clonedSale.signageMetaData.vatCaption = resolvedLocalizationSettings[localizationUtils.attributes.vatCaption];
    clonedSale.signageMetaData.isVatInclusive = resolvedLocalizationSettings[localizationUtils.attributes.isVatInclusive];    
    clonedSale.signageMetaData.isVatApplicable = resolvedLocalizationSettings[localizationUtils.attributes.isVatApplicable]
    clonedSale.signageMetaData.doPrintUnitPriceInSaleReceipt = resolvedLocalizationSettings[localizationUtils.attributes.doPrintUnitPriceInSaleReceipt];

    return clonedSale;
}

module.exports.closeSale = function()
{
    if (terminalUtility.isRunningUnderBrowserShell())
        return;

    var shellAPIServerUrl = getShellApiServerUrl();

    try
    {
        var requestBody = {};
        requestBody.method = 'POST';
        requestBody.headers = {
                                    "Content-Type": "application/json",
                              }
    
        var body = {};
        body.command = "signage.player.close.sale";
        body.payload = null;
        requestBody.body = JSON.stringify(body);
    
        fetch(shellAPIServerUrl, requestBody)
            .then(function(response)
            {
                if (response.status != 200)
                    logger.error(`Invalid response ${response.status} received from hardware services api server (${shellAPIServerUrl}).`);
                else
                    logger.info('Successfully sent payload to hardware services api server.');
                return null;
            }, 
            error =>
            {
                var errorMessage = error.message;
                if (!errorMessage) errorMessage = error;
                logger.error(`Following error reported while accessing hardware services api server (${shellAPIServerUrl}):  ${errorMessage}`, {}, error);
                return null;
            });
    }
    catch(error)
    {
        logger.error(`Following error reported while accessing hardware services api server (${shellAPIServerUrl}):  ${error}`, {}, error);
    }
}

module.exports.openCloseTill = function(isOpen)
{
    if (terminalUtility.isRunningUnderBrowserShell())
        return;

    var shellAPIServerUrl = getShellApiServerUrl();

    try
    {
        var requestBody = {};
        requestBody.method = 'POST';
        requestBody.headers = {
                                    "Content-Type": "application/json",
                              }
    
        var body = {};
        body.command = isOpen ? "signage.player.open.till" : "signage.player.close.till";
        body.payload = null;
        requestBody.body = JSON.stringify(body);
    
        fetch(shellAPIServerUrl, requestBody)
            .then(function(response)
            {
                if (response.status != 200)
                    logger.error(`Invalid response ${response.status} received from hardware services api server (${shellAPIServerUrl}).`);
                else
                    logger.info('Successfully sent payload to hardware services api server.');
                return null;
            }, 
            error =>
            {
                var errorMessage = error.message;
                if (!errorMessage) errorMessage = error;
                logger.error(`Following error reported while accessing hardware services api server (${shellAPIServerUrl}):  ${errorMessage}`, {}, error);
                return null;
            });
    }
    catch(error)
    {
        logger.error(`Following error reported while accessing hardware services api server (${shellAPIServerUrl}):  ${error}`, {}, error);
    }
}

module.exports.chargeTransaction = function(reference, amount)
{
    return this.startTransaction("credit.card.transaction.charge", reference, amount);
}

module.exports.refundTransaction = function(reference, amount)
{
    return this.startTransaction("credit.card.transaction.refund", reference, amount);
}

module.exports.startTransaction = function(command, reference, amount)
{
    if (terminalUtility.isRunningUnderBrowserShell())
        return;

    var shellAPIServerUrl = getShellApiServerUrl();

    try
    {
        var requestBody = {};
        requestBody.method = 'POST';
        requestBody.headers = {
                                    "Content-Type": "application/json",
                              }
    
        var body = {};
        body.command = command;
        body.reference = reference;
        body.amount = amount;
        requestBody.body = JSON.stringify(body);
    
        fetch(shellAPIServerUrl, requestBody)
            .then(function(response)
            {
                if (response.status != 200)
                    logger.error(`Invalid response ${response.status} received from hardware services api server (${shellAPIServerUrl}).`);
                else
                    logger.info('Successfully sent payload to hardware services api server.');
                return null;
            }, 
            error =>
            {
                var errorMessage = error.message;
                if (!errorMessage) errorMessage = error;
                logger.error(`Following error reported while accessing hardware services api server (${shellAPIServerUrl}):  ${errorMessage}`, {}, error);
                return null;
            });
    }
    catch(error)
    {
        logger.error(`Following error reported while accessing hardware services api server (${shellAPIServerUrl}):  ${error}`, {}, error);
    }
}

module.exports.handleSignatureVerificationResponse = function(reference, verified)
{
    if (terminalUtility.isRunningUnderBrowserShell())
        return;

    var shellAPIServerUrl = getShellApiServerUrl();

    try
    {
        var requestBody = {};
        requestBody.method = 'POST';
        requestBody.headers = {
                                    "Content-Type": "application/json",
                              }
    
        var body = {};
        body.command = "credit.card.transaction.signature.verify";
        body.reference = reference;
        body.verification = verified;
        requestBody.body = JSON.stringify(body);
    
        fetch(shellAPIServerUrl, requestBody)
            .then(function(response)
            {
                if (response.status != 200)
                    logger.error(`Invalid response ${response.status} received from hardware services api server (${shellAPIServerUrl}).`);
                else
                    logger.info('Successfully sent payload to hardware services api server.');
                return null;
            }, 
            error =>
            {
                var errorMessage = error.message;
                if (!errorMessage) errorMessage = error;
                logger.error(`Following error reported while accessing hardware services api server (${shellAPIServerUrl}):  ${errorMessage}`, {}, error);
                return null;
            });
    }
    catch(error)
    {
        logger.error(`Following error reported while accessing hardware services api server (${shellAPIServerUrl}):  ${error}`, {}, error);
    }
}


function getShellApiServerUrl()
{
    return `${getShellApiServerCoreUrl()}/RestAPI`;
}

function getShellApiServerCoreUrl()
{
    return `http://localhost:${configurationManager.getConfig().shellApiServerPort}`;
}

